import { ABOUT } from '../../config/site';

export default function About() {
  return (
    <section
      id="about"
      className="relative py-20 md:py-28 bg-dual-nature scroll-mt-[132px] overflow-hidden"
    >
      {ABOUT.image && (
        <>
          <img
            src={ABOUT.image}
            alt={ABOUT.imageAlt}
            loading="lazy"
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover blur-[0.5px] scale-105"
          />
          <div className="absolute inset-0 bg-cream/25" />
        </>
      )}
      <div className="relative max-w-2xl mx-auto px-6 text-center">
        <h2 className="font-display text-3xl md:text-4xl tracking-[0.05em] text-text-primary leading-tight mb-6">
          {ABOUT.heading}
        </h2>
        <p className="font-inter text-sm md:text-base leading-relaxed text-text-primary/80">
          {ABOUT.body}
        </p>
      </div>
    </section>
  );
}
